export interface ProblemDetail {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  message?: string;
  properties?: { trace?: string };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isProblemDetail(value: any): value is ProblemDetail {
  return typeof value === 'object' && value !== null && 'status' in value && 'type' in value;
}
